import { type OpenApiSchemaMenuPossibleCategoryLink } from '../../api/schema';
import { SelectItemWithLevel } from '../../components/SelectItemWithLevel';
import {
    type CategoryWithLevelModel,
    type CategoryWithParentsPath,
    enrichCategoriesWithParentPath,
    setCategoriesLevel,
} from '../category';

type Option = { value: string; label: string; content: React.ReactNode };

type CategoryItem = CategoryWithLevelModel<CategoryWithParentsPath<OpenApiSchemaMenuPossibleCategoryLink>>;

export const mapMenuCategoriesToTreeForSelect = (categories: OpenApiSchemaMenuPossibleCategoryLink[]): Option[] => {
    const categoriesWithParentPaths = setCategoriesLevel(enrichCategoriesWithParentPath(categories));

    const categoryChildById = new Map<OpenApiSchemaMenuPossibleCategoryLink['id'], CategoryItem[]>();

    const categoryById = new Map<OpenApiSchemaMenuPossibleCategoryLink['id'], CategoryItem>();

    categoriesWithParentPaths.forEach((category) => {
        categoryById.set(category.id, category);

        if (category.parent_id) {
            categoryChildById.set(category.parent_id, [...(categoryChildById.get(category.parent_id) ?? []), category]);
        }
    });

    const getCategoryOption = (id: OpenApiSchemaMenuPossibleCategoryLink['id']): Option[] => {
        const category = categoryById.get(id);

        if (!category) {
            return [];
        }

        return [
            {
                value: category.id,
                label: category.parentsPath,
                content: <SelectItemWithLevel title={category.title} id={category.id} level={category.level ?? 0} />,
            },
            ...(categoryChildById.get(id)?.map((child) => getCategoryOption(child.id)) ?? []).flat(),
        ];
    };

    return categoriesWithParentPaths.reduce<Option[]>((options, item) => {
        if (item.level === 0) {
            options.push(...getCategoryOption(item.id));
        }

        return options;
    }, []);
};
